import {
  CLEAR_PROJECTS_COUNT,
  FETCH_PROJECT_BREADCRUMB_INFO,
  FETCH_PROJECT_BREADCRUMB_INFO_FAILURE,
  FETCH_PROJECT_BREADCRUMB_INFO_SUCCESS,
  FETCH_PROJECTS_COUNT_SUCCESS,
} from '@Pages/RetroSynthesis/RsBreadcrumbs/constants';
import { DELETE_PROJECT_SUCCESS, RENAME_PROJECT_SUCCESS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { isObjectLike } from 'lodash/isObjectLike';
import { PROJECT_ROUTES_BULK_DELETE_SUCCESS } from '@Pages/RetroSynthesis/ProjectRoutes/constants';

export class ProjectRoutesCountMapState {
  static LOADING = 'loading';

  static ERROR = 'error';
}

export const initialState = {
  projectsInfoMap: {},
  removedProjectIds: [],
  removedRouteIds: [],
  projectsCount: undefined, // for RsBreadcrumbs and RsRootInitializer
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  const projectsInfoMap = { ...state.projectsInfoMap };
  const { type, projectId, payload } = action || {};
  switch (type) {
    case FETCH_PROJECT_BREADCRUMB_INFO:
      projectsInfoMap[projectId] = ProjectRoutesCountMapState.LOADING;
      break;
    case FETCH_PROJECT_BREADCRUMB_INFO_SUCCESS:
      projectsInfoMap[projectId] = payload;
      break;
    case FETCH_PROJECT_BREADCRUMB_INFO_FAILURE:
      projectsInfoMap[projectId] = ProjectRoutesCountMapState.ERROR;
      break;
    case RENAME_PROJECT_SUCCESS:
      if (isObjectLike(projectsInfoMap[projectId])) {
        projectsInfoMap[projectId] = {
          ...projectsInfoMap[projectId],
          projectName: payload.projectName,
        };
      }
      break;
    case PROJECT_ROUTES_BULK_DELETE_SUCCESS:
      return { ...state, removedProjectIds: [action.projectId], removedRouteIds: [...action.routeIds] };
    case DELETE_PROJECT_SUCCESS:
      return { ...state, removedProjectIds: [...action.projectIds], removedRouteIds: [], projectsCount: undefined };
    case FETCH_PROJECTS_COUNT_SUCCESS:
      return { ...state, projectsCount: payload };
    case CLEAR_PROJECTS_COUNT:
      return { ...state, projectsCount: undefined };
    default:
      return state;
  }
  return { ...state, projectsInfoMap };
}
